<template>
  <div class="page-contato">
    <h1 class="page-title" v-html="$config.strings['lojas-title']"/>
    <div class="table-container" v-if="(lojas.length > 0)">
      <table class="table">
        <tr class="table-header">
          <td class="table-col" v-html="'Endereço'"/>
          <td class="table-col" v-html="'Cidade'"/>
        </tr>
        <tr v-bind:key="loja.endereco" class="table-row" v-for="loja in lojas">
          <td class="table-col" v-html="loja.endereco"/>
          <td class="table-col" v-html="`${loja.cidade} / ${loja.uf}`"/>
        </tr>
      </table>
    </div>
    <t-loading :visible="loading" />
  </div>
</template>

<script>
import { TLoading } from '@/components/base'
import { mapActions } from 'vuex'

export default {
  name: 'pageLojas',
  components: { TLoading },
  data () {
    return {
      lojas: [],
      loading: false
    }
  },
  async mounted () {
    this.loading = true
    try {
      const { data } = await this.getLojas()
      this.lojas = data
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions(['getLojas'])
  }
}
</script>

<style lang="scss" scoped>

.page-contato {
  @include container-element;
  padding-bottom: 30px;
  color: var(--on-secondary-light);
  background-color: var(--on-secondary);

  .page-title {
    margin-Top: 20px;
  }

.table-container {
    overflow-x: auto;
    margin-top: 20px;
    background-color: var(--background);

    @include for-size(phone-only) {
      margin-left: -15px;
      margin-right: -15px;
      padding: 0 30px;
      font-size: 15px;
    }
    .table {
      border-collapse: collapse;
      .table-header {
        background-color: var(--secondary);
        color: var(--on-secondary);
      }
      margin-bottom: 50px;
      min-width: 600px;
      margin-top: 30px;
      width: 100%;
      border-radius: 10px;
      overflow: hidden;

      .table-row {
        background-color: var(--surface);
        color: var(--on-surface);
      }

      .table-col {
        padding: 30px;
        border-left: 1px solid #ddd;
        @include for-size(phone-only) {
          padding: 15px;
        }
      }

      .table-col:first-child {
        border: none;
      }
    }
  }
}
</style>
